// ai supported models

export const GPT_4_OMNI = '4o';
export const GPT_4_TURBO = '4';
export const GPT_35_TURBO = '3';
